/* eslint-disable indent */
import styled, { css } from 'styled-components';
import { mediaMixin } from '@zillow/constellation';

import ConnectedModuleCard from 'app/shared/components/ConnectedModuleCard';

export const StyledConnectedModuleCard = styled(ConnectedModuleCard)`
    ${mediaMixin('lg', css`
        min-height: 510px;
    `)}
`;
